import { db } from './firebaseServices';
import { doc, getDoc, setDoc, updateDoc, runTransaction, serverTimestamp, increment } from 'firebase/firestore';
import { getUserRegion } from '../utils/helpers';

function slugify(text) {
  if (!text) return 'unknown-calculator';
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
}

export async function trackCalculatorClick(calculatorName) {
  if (!calculatorName || typeof calculatorName !== 'string' || calculatorName.trim() === '') {
    console.error("Invalid calculator name provided for tracking:", calculatorName);
    return;
  }

  const slug = slugify(calculatorName);
  if (!slug) {
    console.error("Failed to generate a valid slug for calculator name:", calculatorName);
    return;
  }

  const calculatorDocRef = doc(db, 'products', 'calculatorclicks', slug, 'summary');

  try {
    await runTransaction(db, async (transaction) => {
      const calculatorDocSnap = await transaction.get(calculatorDocRef);

      if (!calculatorDocSnap.exists()) {
        transaction.set(calculatorDocRef, {
          name: calculatorName,
          count: 1,
          firstClicked: serverTimestamp(),
          lastClicked: serverTimestamp()
        });
        console.log(`Firestore: Created new entry for ${calculatorName} (slug: ${slug}), count: 1`);
      } else {
        transaction.update(calculatorDocRef, {
          count: increment(1),
          lastClicked: serverTimestamp()
        });
        console.log(`Firestore: Updated count for ${calculatorName} (slug: ${slug})`);
      }
    });
  } catch (error) {
    console.error(`Firestore: Error tracking click for ${calculatorName} (slug: ${slug}): `, error);
  }
}

export async function updateProductClicks(card) {
  const { uid, uid1, title, title1 } = card;

  const userRegion = await getUserRegion();
  const isUS = userRegion === 'US';

  const collectionName = isUS ? 'usuid' : 'euuid';
  const documentId = isUS ? uid1 : uid;

  const titleToUse = isUS ? (title1 || title || 'Unknown Title') : (title || 'Unknown Title');

  if (!documentId) {
    console.error('Invalid document ID:', documentId);
    return;
  }

  const dataToUpdate = {
    title: titleToUse,
    uid: documentId,
    clicks: 1
  };

  const docRef = doc(db, 'products', 'clicks', collectionName, documentId);
  
  try {
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      await updateDoc(docRef, {
        clicks: increment(1)
      });
    } else {
      await setDoc(docRef, dataToUpdate);
    }
  } catch (error) {
    console.error(`Error updating product clicks for ${documentId}: `, error);
  }
}